import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { StyledLink } from '../../molecules/table/CopyrightCheckerDossierTableRow.style';
const TitleOuterWrapper = styled.div `
    position: relative;
    margin-bottom: 15px;
    padding-bottom: 8px;

    &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 38px;
        height: 3px;
        background-color: ${props => props.theme.headingHighlight};
        border-radius: 2px;
    }
`;
const TitleWrapper = styled.div `
    display: flex;
    align-items: center;
    gap: 10px;
`;
const StyledTitle = styled.h1 `
    color: ${props => props.theme.primary.base};
    font-family: ${props => props.theme.fontHead};
    font-weight: 600;
    font-size: 20px;

    @media only screen and (min-width: 768px) {
        font-size: 24px;
    }

    &::first-letter {
        ${({ titleCapitalizeFirstLetter }) => titleCapitalizeFirstLetter &&
    css `
                text-transform: uppercase;
            `}
    }
`;
export function PageTitle({ icon, subtitle, href, title, titleCapitalizeFirstLetter = true, }) {
    return (_jsxs(TitleOuterWrapper, { children: [_jsxs(TitleWrapper, { children: [title && (_jsx(StyledTitle, { titleCapitalizeFirstLetter: titleCapitalizeFirstLetter, children: title })), icon] }), subtitle ? _jsx(StyledLink, { href: href, children: subtitle }) : null] }));
}
export default PageTitle;
